import React, { Component } from "react";

import { Container } from "react-bootstrap";
import { applyNavigationEffect } from "../../effects/NavigationEffect.js";
import CardWithImageComponent from "../../components/CardWithImageComponent";

class AssociationLogo extends Component {
  componentDidMount() {
    applyNavigationEffect(); // Call the navigation effect
  }

  render() {
    return (
      <div id="association-logo" className="webpage">
        <Container className="main-container">
          <CardWithImageComponent
            id="logo-site-card"
            className="card-with-image"
            header="Vereinslogo"
            image="../../assets/images/general_images/logo-transparent.png"
            text={
              <>
                <b style={{ textAlign: "center !important" }}>
                  Bedeutung und Herkunft des Vereinslogos
                </b>
                <div>
                  <b>Burgverein Hohenfels e. V.</b> <br />
                  Das Vereinslogo des Burgvereins Hohenfels e. V. verbindet zwei
                  wesentliche Seiten der Geschichte des Hohenfels: den Sitz der
                  mittelalterlichen Gerichtsherren und den zugehörigen
                  Gerichtsraum der ehemaligen Cent Dautphe, eines historischen
                  Gerichts- und Verwaltungsbezirks. Historische Überlieferung,
                  regionale Raumbezüge und eine neu entwickelte Symbolik treten
                  darin miteinander in Beziehung.
                  <br />
                </div><br />
                <div>
                  <b>Linker Schild</b> <br />
                  Im Hochmittelalter war der Hohenfels Sitz der Gerichtsherren
                  der Cent Dautphe. Die Burganlage war damit eng mit Verwaltung,
                  Rechtsprechung und Organisation eines weitreichenden
                  Gerichtsbezirks verbunden. <br />
                  An diese historische Bedeutung erinnert der vom Betrachter aus
                  gesehen linke Schild. Er zeigt das überlieferte Wappenzeichen
                  der Herren von Hohenfels: einen stilisierten Adlerflügel.
                  Spätere heraldische Überlieferungen zeigen den Adlerflügel in
                  Silber auf rotem Grund. <br />
                </div><br />
                <div>
                  <b>Rechter Schild</b> <br />
                  Der rechte Schild steht stellvertretend für die überlieferte
                  Gerichtslandschaft der Cent Dautphe und für eine Form der
                  Rechtsprechung, bei der Recht an öffentlich bekannten Orten
                  unter freiem Himmel und vor den Menschen des Gerichtsbezirks
                  gesprochen wurde.
                  <br />
                  Im Gebiet der ehemaligen Cent sind mehrere Plätze überliefert,
                  deren Namen, Lage und örtliche Tradition auf eine frühere
                  Nutzung als Gerichts- oder Versammlungsorte verweisen.
                  Gerichte und öffentliche Versammlungen fanden häufig unter
                  freiem Himmel statt – an Orten, die innerhalb der Landschaft
                  seit Langem bekannt waren und eine besondere Bedeutung
                  besaßen. <br />
                  Herrschaft wurde damit nicht allein durch Burgen und andere
                  Herrschaftsbauten sichtbar. Sie zeigte sich ebenso darin, dass
                  an einem anerkannten Ort und nach überlieferten Regeln Recht
                  gesprochen wurde. <br />
                  Der Eichenkreis im Vereinslogo verdichtet diesen Zusammenhang
                  zu einem gemeinsamen Symbol. Neun Eichen umgeben einen Platz
                  unter freiem Himmel. Im Zentrum befindet sich das Schwert als
                  Zeichen der Gerichtsherrschaft und der rechtlichen Autorität
                  der Herren von Hohenfels.
                  <br />
                </div><br />
                <div>
                  <b>Der verbindende Ritter</b>
                  <br />
                  Der dargestellte Ritter des 13. Jahrhunderts verbindet beide
                  Seiten des Logos. Mit dem vom Betrachter aus linken Schild
                  führt er das überlieferte Wappenzeichen der Herren von
                  Hohenfels. Der rechte Schild verweist auf ihre Funktion als
                  Gerichtsherren der Cent Dautphe und auf den Landschaftsraum,
                  in dem sie Recht ausübten und öffentliche Ordnung wahrten. Der
                  Ritter verbindet damit Herrschaftssitz und Gerichtsraum, den
                  Anlagenkomplex Hohenfels mit der dazugehörigen Cent Dautphe.
                  <br />
                </div><br />
                <div>
                  <b>Historisches Vorbild – heutige Orientierung</b>
                  Die Blütezeit der Herren von Hohenfels lag im Hochmittelalter
                  – einer Epoche, in der sich mit dem Rittertum Vorstellungen
                  von verantwortlichem Handeln verbanden. Diese Leitbilder
                  wirken bis heute in unserem Bild des Rittertums nach. <br />
                  Zugleich erhalten die neun Eichen eine Bedeutung für die Gegenwart. Sie
                  stehen für neun ritterliche Tugenden: Beständigkeit, Anstand,
                  Würde, Demut, Treue, Ehre, Mut, Freigiebigkeit und ein
                  maßvolles Leben.<br /> 
                  Diese an die Ritterzeit angelehnte
                  Werteordnung bietet eine Orientierung für den Umgang mit dem
                  kulturellen Erbe, für das Miteinander in der Gemeinschaft und
                  für die Verantwortung gegenüber diesem besonderen Ort.
                </div>
              </>
            }
            footer={
              <div>
                <span style={{ textAlign: "center" }}>
                  - Burgverein Hohenfels e.V. –
                </span>
                <span style={{ textAlign: "center" }}>Im Juni 2026</span>
              </div>
            }
          />
        </Container>
      </div>
    );
  }
}

export default AssociationLogo;
